import { createReducer, on } from '@ngrx/store';
import * as DomainsActions from './domains.actions';
import { domainsAdapter, initialDomainsState } from './domains.state';

export const domainsReducer = createReducer(
  initialDomainsState,

  // Load domains
  on(DomainsActions.loadDomains, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(DomainsActions.loadDomainsSuccess, (state, { domains }) =>
    domainsAdapter.setAll(domains, {
      ...state,
      loading: false
    })
  ),

  on(DomainsActions.loadDomainsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Load single domain
  on(DomainsActions.loadDomain, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(DomainsActions.loadDomainSuccess, (state, { domain }) =>
    domainsAdapter.upsertOne(domain, {
      ...state,
      loading: false,
      selectedDomainId: domain.id
    })
  ),

  on(DomainsActions.loadDomainFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Add domain record
  on(DomainsActions.addDomainRecord, (state) => ({
    ...state,
    loadingCreate: true,
    error: null
  })),

  on(DomainsActions.addDomainRecordSuccess, (state) => ({
    ...state,
    loadingCreate: false,
    error: null
  })),

  on(DomainsActions.addDomainRecordFailure, (state, { error }) => ({
    ...state,
    loadingCreate: false,
    error
  })),

  // Update domain record
  on(DomainsActions.updateDomainRecord, (state) => ({
    ...state,
    loadingCreate: true,
    error: null
  })),

  on(DomainsActions.updateDomainRecordSuccess, (state) => ({
    ...state,
    loadingCreate: false,
    error: null
  })),

  on(DomainsActions.updateDomainRecordFailure, (state, { error }) => ({
    ...state,
    loadingCreate: false,
    error
  })),

  // Delete domain record
  on(DomainsActions.deleteDomainRecord, (state) => ({
    ...state,
    loadingCreate: true,
    error: null
  })),

  on(DomainsActions.deleteDomainRecordSuccess, (state) => ({
    ...state,
    loadingCreate: false,
    error: null
  })),

  on(DomainsActions.deleteDomainRecordFailure, (state, { error }) => ({
    ...state,
    loadingCreate: false,
    error
  })),

  // Select domain
  on(DomainsActions.selectDomain, (state, { domainId }) => ({
    ...state,
    selectedDomainId: domainId
  }))
);
